import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { Subscription } from 'rxjs';
import { ServicecallService, SubmitButtonClickService } from 'src/app/services';

@Component({
  selector: 'app-contact-us-modal',
  templateUrl: './contact-us-modal.component.html',
  styleUrls: ['./contact-us-modal.component.css']
})
export class ContactUsModalComponent implements OnInit, OnDestroy { 

  @Input() type: any;
  dropdownList: any = ['General Inquiries', 'New Customer', 'Existing Customer', 'Potential Partner']
  userForm: FormGroup;
  submitted: boolean = false;
  disableContactForm: boolean = false;
  selectedValue: any=this.dropdownList[0];

  private _loading: boolean = false;
  private _enquirySubscription: Subscription;

  
  constructor(
    private _activeModal: NgbActiveModal,
    private _router: Router,
    private _service: ServicecallService,
    private _fb: FormBuilder,
    private _submitButtonClick: SubmitButtonClickService
  ) {
    this.userForm = this._fb.group({
      'inquiryType': [this.selectedValue, Validators.required],
      'name': ['', [Validators.required,Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]],
      'organization': ['', [Validators.required,Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]],
      'contact': [],
      'message': [''],
    });
  }

  ngOnInit(): void {
    // TODO document why this method 'ngOnInit' is empty
  }
  ngOnDestroy(): void {
    this._enquirySubscription?.unsubscribe(); 
  }
  get formValues() {
    return this.userForm.controls;
  }

  getChangedValue(selectedValue: any) {
    this.selectedValue = selectedValue;
    this.userForm.patchValue({ inquiryType: this.selectedValue })
  }

  loginDemo() {
    this._submitButtonClick.setSubmitButtonClick('clicked');
    this.submitted = true;
    this._loading = true;
    // this.userForm.patchValue({ inquiryType: this.selectedValue })
    const dialCode = this.userForm.value.contact.number?.dialCode;
    const countryCode = dialCode?.substring(1);
    this.userForm.value.phone = countryCode?.concat(this.userForm.value.contact.number.number);
    this.userForm.value.email = this.userForm.value.contact.email;
    const request = {
      'inquiryType' : this.userForm.value.inquiryType,
      'name': this.userForm.value.name,
      'organization': this.userForm.value.organization,
      "phone": {
        "country": this.userForm.value.contact?.number ? this.userForm.value.contact?.number?.countryCode: 'IN',
        "countryCode":this.userForm.value.contact?.number?.dialCode,
        "number":this.userForm.value.contact?.number?.number,
      },
      'email': this.userForm.value.email,
      'message': this.userForm.value.message,
    }
    if (this.userForm.invalid) {
      this._loading = false;
      return;
    }
    this._enquirySubscription = this._service.enquiry(request).subscribe((result: any) => {
      if (result['status']) {
        if (result['response']) {
          this._loading = false;
          this.submitted = false;
          this._service.toasterService({ type: 'success', msg: result["response"]["message"] });
          this._activeModal.close();
          this._router.navigate(['/'])
        }
        else {
          this._loading = false;
          this.submitted = false;
          this._service.toasterService({ type: 'error', msg: result["response"]["message"] });
        }
      }
      else {
        this._loading = false;
        this.submitted = false;
        this._service.toasterService({ type: 'error', msg: result["response"]["message"] });
      }
    });
  }

  close() {
    this.submitted = false;
    this._activeModal.close();
  }

}
